import React, { useEffect, useState } from "react";
import { Box, Tabs, Tab, Typography } from "@mui/material";
import { useParams } from "react-router-dom";

// ✅ use central API service (DO NOT use axios directly)
import api from "../../api/api";
import TeamTab from "./tabs/TeamTab";
import OverviewTab from "./tabs/OverviewTab";
import WorkItemsTab from "./tabs/WorkItemsTab";
import SprintTab from "./tabs/SprintTab";

export default function ProjectDetailsPage() {

  const { id } = useParams();
  const [project, setProject] = useState(null);
  const [tab, setTab] = useState(0);

  useEffect(() => {
    if (id) {
      fetchProject();
    }
  }, [id]);

  // ==========================================================
  // FETCH PROJECT DETAILS
  // ==========================================================

  const fetchProject = async () => {
    try {

      const res = await api.get(`/projects/${id}`);

      setProject(res.data);

    } catch (err) {

      console.error("Error loading project", err);

    }
  };

  if (!project) return <Typography>Loading...</Typography>;

  return (

    <Box>

      {/* ======================================================
          PAGE HEADER
      ====================================================== */}

      <Typography variant="h4" mb={1}>
        {project.name}
      </Typography>

      {/* ⭐ FIXED: Safe Client Display */}
      {/* Shows client_name if available otherwise client_id */}

      {project.client_name ? (
        <Typography variant="body2" color="text.secondary" mb={2}>
          Client: {project.client_name}
        </Typography>
      ) : project.client_id ? (
        <Typography variant="body2" color="text.secondary" mb={2}>
          Client ID: {project.client_id}
        </Typography>
      ) : null}

      {/* ======================================================
          TABS NAVIGATION
      ====================================================== */}

      <Tabs value={tab} onChange={(e, v) => setTab(v)}>

        <Tab label="Overview" />

        <Tab label="Team" />

        <Tab label="Work Items" />

        {project.project_type === "DEVELOPMENT" && (
          <Tab label="Sprint" />
        )}

      </Tabs>

      {/* ======================================================
          TAB CONTENT
      ====================================================== */}

      <Box mt={3}>

        {tab === 0 && (
          <OverviewTab projectId={id} project={project} />
        )}

        {tab === 1 && (
          <TeamTab project={project} />
        )}

        {tab === 2 && (
          <WorkItemsTab projectId={id} />
        )}

        {tab === 3 &&
          project.project_type === "DEVELOPMENT" && (
            <SprintTab projectId={id} />
          )
        }

      </Box>

    </Box>

  );

}